import { useNavigate } from "react-router-dom";
import "./AcademicsPage.css";

function DegreeAcademics() {

  const navigate = useNavigate();

  return (
    <div className="degree-page">

      {/* TOP IMAGE CARDS */}
      <div className="image-links-container">

       <div className="image-card" onClick={() => navigate("/courses-offered")}>
          <img src="/images/course-offered.png" alt="Courses Offered" />
          <h3>Courses Offered</h3>
        </div>

        <div className="image-card" onClick={() => navigate("/academic-calendar")}>
          <img src="/images/academic-calender.png" alt="Academic Calendar" />
          <h3>Academic Calendar</h3>
        </div>

        <div className="image-card" onClick={() => navigate("/facilities")}>
          <img src="/images/facilities-page.png" alt="Facilities" />
          <h3>Facilities</h3>
        </div>

        <div className="image-card" onClick={() => navigate("/achievements")}>
          <img src="/images/achievements.png" alt="Achievements" />
          <h3>Achievements</h3>
        </div>

      </div>


      {/* COURSE CONTENT */}
      
      

    </div>
  );
}

export default DegreeAcademics;

